let loopCount = 0;
export function addToLoopCount() {
    return loopCount++;
}
export function resetLoopCount() {
    loopCount = 0;
    return loopCount;
}
export function getLoopCount() {
    return loopCount;
}
